/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { GetCurrentUserOptions, GetCurrentUserResponses } from '../../models/GetCurrentUser'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Auth Current User
 * {@link /auth/current-user}
 */
export function getCurrentUser<ThrowOnError extends boolean = true>(options: Options<GetCurrentUserOptions, ThrowOnError> = {}): Promise<UnwrappedResult<GetCurrentUserResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/auth/current-user', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<GetCurrentUserResponses, ThrowOnError>>
}
